import React, {useEffect, useRef, useState} from 'react'
import {
  activateFavoriModifPrix,
  createFavoriModifPrix,
  deleteFavoriModifPrix,
  deletePrix,
  exportPrix,
  getEquipeUtilisateur,
  getFavoriModifPrix,
  getModifPrix,
  getSiteAll,
  getSyncpiecesprixSd,
  modifPrixImport,
  updateFavoriModifPrix,
} from '../../../components/requests'
import {toast} from 'react-toastify'
import {ModeleEditEquipe, ModeleModifPrix, ModeleSourcePiece} from '../../../components/Models'
import {useFormik} from 'formik'
import {LoadingData} from '../../../components/LoadingData'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {Pagination} from '../../../components/Pagination'
import moment from 'moment'
import {useAuth} from '../../modules/auth'
import {DateInput} from '../../../components/inputs/DateInput'
import Swal from 'sweetalert2'
import {DetailsModal} from '../catalogues/components/DetailsModal'
import './css/style.css'
import TableFilter from '../demande/Components/TableFilter'
import Select, {components} from 'react-select'
import {SearchDropDown} from '../../../components/SearchDropDown'
import CustomOption from '../demande/Components/CustomOption'
import {copyText} from '../../../components/renders'
import {Modal} from 'bootstrap'
import FavorisModifPrixPopper from './components/FavorisModifPrixPopper'

const ModifPrixListPage = () => {
  //get date du jour
  let today = new Date()
  today.setMonth(today.getMonth() - 1)
  const formattedDateMinus = today.toISOString().split('T')[0]

  const [loading, setLoading] = useState(false)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<any>(1)
  const [isSearch, setIsSearch] = useState(false)
  const [dataModifPrix, setDataModifPrix] = useState<Array<ModeleModifPrix>>([])
  const [dateDebut, setDateDebut] = useState<string | null>('') // valeur par defaut est la dte du jour loins 1 mois
  const [dateFin, setDateFin] = useState<string | null>('')
  const [totalNonTraitee, setTotalNonTraitee] = useState<number>(0)
  const [totalTraitee, setTotalTraitee] = useState<number>(0)
  const [totalPrixManuel, setTotalPrixManuel] = useState<number>(0)
  const [traitee, setTraitee] = useState<string | null>('prixManuel')
  const [isAllSelected, setIsAllSelected] = useState(false)
  const [checkedModifPrice, setCheckedModifPrice] = useState<any>([])
  const [totalElement, setTotalElement] = useState<any>(0)
  const [activeBtn, setActiveBtn] = useState(false)
  const [activeSearch, setActiveSearch] = useState(false)
  const isFirstLoad = useRef(true)
  const [dataModal, setDataModal] = useState<any>('')
  const abortController = useRef<AbortController | null>(null)
  const [sources, setSources] = useState<any>([])
  const [sourcesSearch, setSourceSearch] = useState<any>([])
  const [displayFilter, setDisplayFilter] = useState<boolean>(false)
  const [searchPage, setSearchPage] = useState<any>('')
  const [isPageNext, setIsPageNext] = useState<boolean>(false)
  const [isNothingToNext, setIsNothingToNext] = useState(false)

  const [listeNompiece, setListeNompiece] = useState<any>([]) // nom des pièces
  const [libelles, setLibelles] = useState<any>([])
  const [selectedLibelles, setSelectedLibelles] = useState<any>([])
  const [selectedEquipes, setSelectedEquipes] = useState<any>([])
  const [menuInputValue, setMenuInputValue] = useState<string>('')
  const traiteeChangedRef = useRef(false)

  const dataModifPrixRef = useRef<any>([])

  const [sortField, setSortField] = useState<
    | 'source'
    | 'statut'
    | 'codePiece'
    | 'libPiece'
    | 'marque'
    | 'modele'
    | 'prixVente'
    | 'nouveauPrix'
    | 'dateImport'
    | 'refConst'
    | null
  >(null)
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc')

  // const refPrix = useRef<HTMLTableDataCellElement | null>(null)
  const refPrix = useRef<Record<string, HTMLTableRowElement | HTMLTableCellElement | null>>({})
  const [currentIndex, setCurrentIndex] = useState(0)

  const [checkCopy, setCheckCopy] = useState<string | null>(null)

  const {currentUser} = useAuth()
  const fileInputRef = useRef<any>(null)

  const API_URL = process.env.REACT_APP_API_URL
  const exportUrl = `${API_URL}/export/modificationPrix`

  const [openFavorisModif, setOpenFavorisModif] = useState<boolean>(false)
  const [favoriModifLoader, setFavoriModifLoader] = useState<boolean>(false)
  const [favorisDeleteModifLoader, setFavorisDeleteModifLoader] = useState<{
    [key: string]: boolean
  }>({})
  const [favoriUpdateLoader, setFavoriUpdateLoader] = useState<{
    [key: string]: boolean
  }>({})
  const [onEdit, setOnEdit] = useState<boolean>(false)
  const [filters, setFilters] = useState<{
    dateDebut: string | null
    dateFin: string | null
    traitee: string | null
    sourcesSearch: any
    searchPage: string
    tri: {
      key: string | null
      order: string | null
    }
    libellePiece: any
    equipe: any
  }>({
    dateDebut: '',
    dateFin: '',
    traitee: null,
    sourcesSearch: [],
    searchPage: '',
    tri: {
      key: null,
      order: null,
    },
    libellePiece: [],
    equipe: [],
  })
  const [favoriModifPrix, setFavoriModifPrix] = useState<any>([])
  const [isFavoriLoaded, setIsFavoriLoaded] = useState(false)
  const [filterTitle, setFilterTitle] = useState<string>('')
  const [shareWithTeam, setShareWithTeam] = useState<boolean>(false)
  const [equipes, setEquipes] = useState<Array<ModeleEditEquipe>>([])
  // Ne pas ajouter equipe si non autorisé
  const allowedToManageFavori = shouldDisplayFonctionnalite(currentUser, 'GESTION FAVORI')
  // Style du select pour le filtre des sources
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '45px',
      minWidth: '200px',
    }),
  }

  // Style du select pour le filtre des libellés
  const selectLibelleStyle = {
    control: (base) => ({
      ...base,
      minHeight: '45px',
      minWidth: '200px',
      maxHeight: '60px',
      overflowY: 'auto',
    }),
  }

  // Données formatées pour le filtre des sources
  const getSourceData = () => {
    getSiteAll()
      .then((sourceRequest) => {
        const transformedData = sourceRequest.map((item) => ({
          value: item.code,
          label: item.nom ?? item.code,
        }))
        setSources([...transformedData])
      })
      .catch((e) => {})
  }

  const getModificationPrixData = () => {
    if (abortController.current) {
      abortController.current.abort()
    }
    const controller = new AbortController()
    abortController.current = controller

    let libellePiece = 'tous'
    const tousExist = selectedLibelles?.some(
      (item) => item.value === 'tous' && item.label === 'Tous'
    )
    if (!tousExist) { // envoyer "tous" si "Tous" est coché dans la liste des libellés pièces
      const libelleFilter = selectedLibelles?.filter((item) => item.value !== 'tous')
      if (libelleFilter?.length > 0) {
        libellePiece = libelleFilter?.map((item) => item.label).join(', ')
      }
    }

    setLoading(true)
    getModifPrix(
      !isSearch ? currentPage : 1,
      dateDebut,
      dateFin,
      traitee,
      sourcesSearch,
      searchPage,
      sortOrder,
      sortField,
      libellePiece,
      controller.signal
    )
      .then((modificationPrixRequest) => {
        setNombreDePages(modificationPrixRequest?.pages)
        setTotalPages(modificationPrixRequest?.total)
        setCurrentPage(modificationPrixRequest?.page ?? 1)

        const totalItems = modificationPrixRequest?.totalItems //total statut filter

        //gestion total statut
        const totalInit = modificationPrixRequest?.totalInit // total initial
        // if (traitee === 'traitee') {
        //   setTotalTraitee(totalItems?.totalTraitee ?? 0)
        //   setTotalNonTraitee(totalInit?.totalNonTraitee ?? 0)
        //   setTotalPrixManuel(totalInit?.totalPrixManuel ?? 0)
        // } else if (traitee === 'prixManuel') {
        //   setTotalPrixManuel(totalItems?.totalPrixManuel ?? 0)
        //   setTotalTraitee(totalInit?.totalTraitee ?? 0)
        //   setTotalNonTraitee(totalInit?.totalNonTraitee ?? 0)
        // } else if (traitee === 'nonTraitee') {
        //   setTotalNonTraitee(totalItems?.totalNonTraitee ?? 0)
        //   setTotalTraitee(totalInit?.totalTraitee ?? 0)
        //   setTotalPrixManuel(totalInit?.totalPrixManuel ?? 0)
        // } else {
        //   setTotalTraitee(totalInit?.totalTraitee ?? 0)
        //   setTotalNonTraitee(totalInit?.totalNonTraitee ?? 0)
        //   setTotalPrixManuel(totalInit?.totalPrixManuel ?? 0)
        //   setTotalElement(totalInit?.totalElement ?? 0)
        // }

        setTotalPrixManuel(totalItems?.totalPrixManuel ?? 0)
        setTotalTraitee(totalItems?.totalTraitee ?? 0)
        setTotalNonTraitee(totalItems?.totalNonTraitee ?? 0)

        if (modificationPrixRequest?.data !== undefined) {
          setDataModifPrix(modificationPrixRequest?.data)
          setListeNompiece(modificationPrixRequest?.listeNompiece)
          setLoading(false)
          setIsSearch(false)
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  const envoiAtemoChange = () => {
    Swal.fire({
      title: 'Attention',
      text:
        'Êtes-vous sûr de vouloir traiter tous les non traités (' +
        (checkedModifPrice.length ? checkedModifPrice.length : totalNonTraitee) +
        ') ?',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        syncPiecesPrix()
      }
    })
  }

  const syncPiecesPrix = () => {
    const idToastAtemo = toast.loading('Envoi en cours...')
    getSyncpiecesprixSd(
      checkedModifPrice?.map((item) => item.id),
      dateDebut,
      dateFin,
      traitee,
      sourcesSearch,
      searchPage
    )
      .then((syncPrixRequest) => {
        if (syncPrixRequest?.data && syncPrixRequest?.status === 200) {
          toast.update(idToastAtemo, {
            render: syncPrixRequest?.data?.success
              ? 'Envoi effectué avec succès'
              : `Échec lors de l'envoi${
                  syncPrixRequest?.data?.code
                    ? `, code pièce inconnu : ${syncPrixRequest.data.code}`
                    : ''
                }`,
            type: syncPrixRequest?.data?.success ? 'success' : 'error',
            isLoading: false,
            autoClose: 3000,
          })
          if (syncPrixRequest?.data?.success) {
            setCheckedModifPrice([])
            if (syncPrixRequest?.data?.success) {
              setDataModifPrix(
                checkedModifPrice?.length
                  ? (prev) =>
                      prev.map((data) =>
                        checkedModifPrice?.map((item) => item.id)?.includes(data?.id)
                          ? {...data, traitee: 1}
                          : data
                      )
                  : (prev) =>
                      prev.map((data) =>
                        dataModifPrix?.map((item) => item.id)?.includes(data?.id)
                          ? {...data, traitee: 1}
                          : data
                      )
              )

              const nonTraitee = checkedModifPrice.length
                ? checkedModifPrice?.filter((item) => item?.traitee === 0 && item?.prixManuel === 0)
                    ?.length
                : dataModifPrix?.filter((item) => item?.traitee === 0 && item?.prixManuel === 0)
                    ?.length

              const prixManuel = checkedModifPrice.length
                ? checkedModifPrice?.filter((item) => item?.traitee === 0 && item?.prixManuel === 1)
                    ?.length
                : dataModifPrix?.filter((item) => item?.traitee === 0 && item?.prixManuel === 1)
                    ?.length

              setTotalNonTraitee(totalNonTraitee - nonTraitee)
              setTotalPrixManuel(totalPrixManuel - prixManuel)
              setTotalTraitee(totalTraitee + (nonTraitee + prixManuel))
              setCheckedModifPrice([])
            }
          }
        }
      })
      .catch((e) => {
        console.log('error ', e)
      })
  }

  useEffect(() => {
    if (sessionStorage.getItem('libelleFilter') !== null) {
      sessionStorage.removeItem('libelleFilter')
    }
    getSourceData()
    fetchModifPrixFavori()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isFavoriLoaded || isSearch) {
      getModificationPrixData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, traitee, activeSearch, sortOrder, sortField, isFavoriLoaded])

  useEffect(() => {
    const libelleFilter = selectedLibelles.filter((item) => item.value !== 'tous')
    if (
      dateDebut === '' &&
      dateFin === '' &&
      searchPage === '' &&
      sourcesSearch === '' &&
      libelleFilter.length === 0
    ) {
      setActiveBtn(false)
    } else {
      setActiveBtn(true)
    }

    //controle sur les champs dateDebut et dateFin
    if(dateDebut !== null && dateFin !== null){
        if ((dateFin !== ''&& dateFin !== '') && (dateDebut > dateFin)){
          toast.warning('Veuillez saisir une date de début inférieur à la date de fin.')
          setActiveBtn(false)
        }
    }

  }, [dateDebut, dateFin, searchPage, sourcesSearch, selectedLibelles])

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      if (file.type !== 'text/csv') {
        toast.error('Le fichier doit être un CSV !')
        return
      }
      const idToastValidate = toast.loading('Import en cours...')
      const formData: FormData = new FormData()
      formData.append('file', file)
      modifPrixImport(formData)
        .then((res) => {
          if (res && res?.status === 200) {
            getModificationPrixData()
            toast.update(idToastValidate, {
              render: 'Import effectué avec succès',
              type: 'success',
              isLoading: false,
              autoClose: 3000,
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
      fileInputRef.current.value = null
    }
  }

  const formik = useFormik({
    initialValues: {dateDebut: '', dateFin: '', sourcesSearch: '', searchPage: ''},
    onSubmit: (values, {setSubmitting}) => {
      setTimeout(() => {
        console.log('system submit')
      }, 1000)
    },
  })

  const handleStatut = (traitee, prixManuel) => {
    if (traitee) {
      return (
        <span className='badge badge-light-success' style={{marginBlock: '2px'}}>
          Traitée
        </span>
      )
    } else {
      if (prixManuel === 1) {
        return <span className='badge badge-light-info'>A tarifier manuellement</span>
      }
      return <span className='badge badge-light-warning'>En attente</span>
    }
  }

  const handleSelectAll = () => {
    if (!dataModifPrix) return
    if (isAllSelected) {
      setCheckedModifPrice([])
    } else {
      const allIds = dataModifPrix
        .filter((item) => item.traitee === 0)
        .map((item) => ({
          id: item?.id,
          prixManuel: item?.prixManuel,
          traitee: item?.traitee,
        }))
      setCheckedModifPrice(allIds)
    }
    setIsAllSelected(!isAllSelected)
  }

  const addPriceAtemo = (checked, price) => {
    setCheckedModifPrice((prevArray) =>
      checked
        ? [...prevArray, price]
        : prevArray.filter((checkedPiece) => checkedPiece?.id !== price?.id)
    )
  }

  const handleStatusChange = (chr) => {
    if (chr === 'traitee') {
      if (!dateDebut) {
        setDateDebut(formattedDateMinus)
        formik.setFieldValue('dateDebut', formattedDateMinus)
      }
    }else{
      setDateDebut("")
      setDateFin("")
    }

    setTraitee(chr)
    setCurrentPage(1)
    setIsSearch(true)
  }

  const deletePrice = () => {
    Swal.fire({
      title: 'Attention',
      text: 'Êtes-vous sûr de vouloir supprimer les (' + checkedModifPrice?.length + ' ) prix ?',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        const idToastDelete = toast.loading('Suppression en cours...')
        deletePrix(checkedModifPrice?.map((item) => item.id))
          .then((deleteRequest) => {
            if (deleteRequest) {
              toast.update(idToastDelete, {
                render: 'Suppression effectué avec succès',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
              setCheckedModifPrice([])
              getModificationPrixData()
            }
          })
          .catch((e) => {
            console.log('error ', e)
          })
      } else {
        console.log('dans la fonction non confirmé')
      }
    })
  }

  // à verifier
  useEffect(() => {
    const dataModifPrixFiltered = dataModifPrix.filter((item) => item.traitee === false)
    const allIdsPresent =
      checkedModifPrice?.length === 0
        ? false
        : dataModifPrixFiltered.every((item) =>
            checkedModifPrice?.map((item) => item.id).includes(item.id)
          )

    if (!allIdsPresent) {
      setIsAllSelected(false)
    }
  }, [currentPage, checkedModifPrice, dataModifPrix, traitee])

  const showDetail = async (dataPrix: any) => {
    const index = dataModifPrix?.findIndex((item) => item?.idPieceEntree === dataPrix?.idPieceEntree)
    setCurrentIndex(index)
    setDataModal(dataPrix)
    setIsPageNext(false)

    // Ouvrir le modal manuellement sans utiliser data-bs
    // Sinon copier / check le checkbox va trigger l'affichage du modal
    const modalEl = document.getElementById('modal_details_cat')
    if (modalEl) {
      const modal = Modal.getOrCreateInstance(modalEl)
      modal.show()
    }
  }

  const exportDataCsv = () => {
    if (dataModifPrix.length > 0) {
      try {
        const idToastExport = toast.loading('Téléchargement en cours...')
        exportPrix(dataModifPrix).then((requestResponse) => {
          if (requestResponse?.status === 200) {
            if (requestResponse?.data !== undefined) {
              let urlUpload = exportUrl + '/' + requestResponse?.data?.url

              // Créer un lien de téléchargement temporaire
              const link = document.createElement('a')
              link.href = urlUpload
              link.download = requestResponse?.data?.url // Nom du fichier téléchargé
              document.body.appendChild(link)
              link.click() // Clique sur le lien pour démarrer le téléchargement
              document.body.removeChild(link)
              toast.update(idToastExport, {
                render: 'Téléchargement effectué avec succès',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
            }
          }
        })
      } catch (ex) {
        console.error(ex)
      }
    }
  }

  // condition d'affichage du libellé "passer au suivant"
  useEffect(() => {
    const dataLength = dataModifPrix.length
    if (currentIndex === dataLength - 1 && nombreDePages === currentPage) {
      setIsNothingToNext(true)
    } else {
      setIsNothingToNext(false)
    }
  }, [dataModifPrix, currentPage, currentIndex])

  //vérification si y a encore une page suivante par rapport au page atuelle => pour passer à l'intégration argus suivante ou pas
  useEffect(() => {
    dataModifPrixRef.current = dataModifPrix
    if (isPageNext) {
      const dataModifPrixShow: any = dataModifPrix[0]
      if (dataModifPrixShow) {
        const timeout = setTimeout(() => {
          const target = refPrix.current[dataModifPrixShow?.idPieceEntree]
          if (target) target.click() // ouverture des données suivantes
        }, 1000)
        return () => clearTimeout(timeout)
      }
    }
  }, [dataModifPrix])

  const showNextModal = (isAborted = false) => {
    const dataModifCurrent = dataModifPrixRef.current

    const indexDernierZero = dataModifCurrent.findLastIndex((item) => item?.prixManuel === 0) // index du dernière donnée avec un prix qui est déjà traiter

    if (dataModifCurrent.length) {
      if (
        currentPage < nombreDePages &&
        (currentIndex === dataModifCurrent.length - 1 ||
          indexDernierZero === dataModifCurrent.length - 1)
      ) {
        setIsPageNext(true)
        if (isAborted) {
          setCurrentPage(currentPage + 1)
        } else {
          getModificationPrixData()
        }
      } else {
        const dataModifPrixShow: any = dataModifCurrent[currentIndex + 1]
        if (dataModifPrixShow) {
          if (dataModifPrixShow?.prixManuel === 0) {
            //si le current data a un statut en attente, on saute sur le statut 'tarification manuel'
            const indexPremierZero = dataModifCurrent.findIndex((item) => item?.prixManuel === 0)
            const result = dataModifCurrent
              .slice(indexPremierZero + 1)
              .find((item) => item.prixManuel === 1)
            setCurrentIndex(indexPremierZero + 1)
            const target = refPrix.current[result?.idPieceEntree]
            if (target) target.click() // ouverture des données suivantes
          } else {
            setCurrentIndex(currentIndex + 1)
            const target = refPrix.current[dataModifPrixShow?.idPieceEntree]
            if (target) target.click() // ouverture des données suivantes
          }
        }
      }
    }
  }

  useEffect(() => {
    if (isFavoriLoaded || isSearch) {
      getModificationPrixData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortOrder, sortField, isFavoriLoaded])

  useEffect(() => {
    traiteeChangedRef.current = true
  }, [traitee])

  const selectedLibellesRef = useRef(true)
  useEffect(() => {
    const activeFavoris = favoriModifPrix?.filter((fav) => fav?.actif)
    const libelleFilter = JSON.parse(sessionStorage.getItem('libelleFilter') ?? '[]')
    if (listeNompiece.length > 0) {
      const transformedData = listeNompiece.map((item, key) => ({
        value: item,
        label: item,
      }))
      const options = [{value: 'tous', label: 'Tous'}, ...transformedData]
      setLibelles(options)
      setSelectedLibelles(
        activeFavoris[0]?.filterData?.libellePiece?.length > 0
          ? activeFavoris[0].filterData.libellePiece
          : libelleFilter.length > 0
          ? libelleFilter
          : options
      )
      // traiteeChangedRef.current = false
    }
  }, [listeNompiece])

  const filterOptions = (candidate: any, input: string) => {
    if (input) {
      return candidate.label.toLowerCase().includes(input.toLowerCase())
    }
    return true
  }

  const handleLibelleChange = (data) => {
    const libellesSansTous = libelles.filter((item) => item.value !== 'tous')
    const hasTous = data.some((item) => item.value === 'tous') // donner modifier => 'tous'
    const hadTous = selectedLibelles.some((item) => item.value === 'tous') // donner sélectionner => 'tous'

    if (data.length === 0) {
      if (sessionStorage.getItem('libelleFilter') !== null) {
        sessionStorage.removeItem('libelleFilter')
      }
      setSelectedLibelles([])
    } else if (hasTous && !hadTous) {
      if (sessionStorage.getItem('libelleFilter') !== null) {
        sessionStorage.removeItem('libelleFilter')
      }
      // cocher "Tous" => tout sélectionner
      setSelectedLibelles(libelles)
    } else if (!hasTous && hadTous) {
      // décocher "Tous" => tout vider
      if (sessionStorage.getItem('libelleFilter') !== null) {
        sessionStorage.removeItem('libelleFilter')
      }
      setSelectedLibelles([])
    } else if (!hasTous) {
      // sélection sans "Tous"
      const dataModif = data.filter((item) => item.value !== 'tous')
      // si tous les items sont cochés => cocher "Tous" aussi
      if (dataModif.length === libellesSansTous.length) {
        if (sessionStorage.getItem('libelleFilter') !== null) {
          sessionStorage.removeItem('libelleFilter')
        }
        setSelectedLibelles(libelles)
      } else {
        sessionStorage.setItem('libelleFilter', JSON.stringify(dataModif)) //session pour stocker les libelles du filtre (traitée, non traitée, tarification manuelle)
        setSelectedLibelles(dataModif)
      }
    } else {
      // si cocher un (ou plusieur) qui est différent de tous
      const dataModif = data.filter((item) => item.value !== 'tous')
      setSelectedLibelles(dataModif)
    }
  }

  const handleCopie = (texte, e) => {
    e.stopPropagation()
    copyText(texte, setCheckCopy, 500)
  }

  const onDeleteData = (dataId) => {
    // Pour mettre à jour à afficher dans le tableau après suppression
    setDataModifPrix((prevD) => prevD.filter((item) => item.id != dataId))
  }

  useEffect(
    function reRenderFilters() {
      setFilters((prev) => ({
        ...prev,
        dateDebut: dateDebut,
        dateFin: dateFin,
        traitee: traitee,
        sourcesSearch: sourcesSearch,
        searchPage: searchPage,
        tri: {
          key: sortField,
          order: sortOrder,
        },
        libellePiece: selectedLibelles,
        equipe: selectedEquipes
      }))
      setShareWithTeam(selectedEquipes?.length > 0)
    },
    [dateDebut, dateFin, traitee, sourcesSearch, searchPage, sortOrder, sortField, selectedLibelles, selectedEquipes]
  )

  useEffect(function purgeSelectedEquipe(){
    if (!shareWithTeam) setSelectedEquipes([])
  }, [shareWithTeam])

  const fetchModifPrixFavori = async () => {
    setFavoriModifLoader(true)
    try {
      const res = await getFavoriModifPrix(currentUser?.id)
      if (res.data && res?.status === 200) {
        const favorisData = res.data.map((fav) => ({
          ...fav,
          actif: !!fav.actif,
        }))

        if (res?.data?.length !== 0) {
          const activeFavoris = favorisData.find((fav) => fav?.actif)
          if (activeFavoris) {
            applyFilterModifPrix(activeFavoris?.filterData)
            setFavoriModifPrix(favorisData)
            return // getModificationPrixData will be triggered by setActiveSearch in applyFilterModifPrix
          }
          setFavoriModifPrix(favorisData)
        }
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des favoris :', error)
    } finally {
      setFavoriModifLoader(false)
      setIsFavoriLoaded(true)
    }
  }

  const handleModifPrixFavoriDelete = async (idFavori, actif) => {
    setFavorisDeleteModifLoader((prev) => ({...prev, [idFavori]: true}))
    try {
      const res = await deleteFavoriModifPrix(idFavori)
      if (res.data && res.status === 200) {
        setIsFavoriLoaded(false)
        setFavoriModifPrix((prev) => {
          const updated = prev.filter((fav) => fav.id !== idFavori)
          if (updated.length === 0 || actif) {
            setFilters({
              dateDebut: '',
              dateFin: '',
              traitee: null,
              sourcesSearch: [],
              searchPage: '',
              tri: {key: null, order: null},
              libellePiece: [],
              equipe: []
            })
            initialFiltersData()
          }
          return updated
        })
        setIsFavoriLoaded(true)
      }
    } catch (error) {
      console.error('Erreur lors de la suppression du favori :', error)
    } finally {
      setFavorisDeleteModifLoader((prev) => ({...prev, [idFavori]: false}))
    }
  }

  const handleModifPrixFavoriUpdate = async (idFavori, filters, favoriTitle) => {
    setOpenFavorisModif(false)
    setFilterTitle(favoriTitle)
    setFavoriUpdateLoader((prev) => ({...prev, [idFavori]: true}))
    const toastFavUpdate = toast.loading('Mise à jour du favori en cours...')
    try {
      const res = await updateFavoriModifPrix(idFavori, filters, favoriTitle)

      if (res.data && res.status === 200) {
        // Màj titre du favori
        setFavoriModifPrix((prev) =>
          prev.map((item) =>
            item.id === idFavori ? {...item, libelle: favoriTitle, filterData: filters} : item
          )
        );
        toast.update(toastFavUpdate, {
          render: 'Favori mis à jour avec succès',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
      } else {
        toast.update(toastFavUpdate, {
          render: 'Mise à jour échouée',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      }
    } catch (error) {
      console.error('Erreur', error)
      toast.update(toastFavUpdate, {
        render: 'Mise à jour échouée',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      })
    } finally {
      setFavoriUpdateLoader((prev) => ({...prev, [idFavori]: false}))
    }
  }

  const handleFavorisModifPrixCreation = async ()  => {
    setOpenFavorisModif(false)
    const idToastFavoriSave = toast.loading('Création du Favori en cours...')

    try {
      const res = await createFavoriModifPrix(currentUser?.id, filters, filterTitle)

      if (res.data && res.status === 200) {
        setIsFavoriLoaded(false)
        await fetchModifPrixFavori() // Récupération des favoris
        toast.update(idToastFavoriSave, {
          render: 'Favori créé avec succès',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })

      } else {
        toast.update(idToastFavoriSave, {
          render: 'Échec lors de la création du favori',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      }
    } catch (error) {
      toast.update(idToastFavoriSave, {
        render: 'Échec lors de la création du favori',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      })
    }
  }

  const applyFavoris = (favoris) => {
    if (!favoris) return

    setOnEdit(false)

    setIsFavoriLoaded(false)
    const isAlreadyActive = favoris?.actif;

    setFilterTitle(favoris?.libelle)

    if (isAlreadyActive) {
      // Désactivation
      handleFavoriModifPrixActivation(favoris, false);

      setFavoriModifPrix((prev) =>
        prev.map((item) => ({
          ...item,
          actif: false,
        }))
      );

    } else {
      // Sélectionner le favori
      handleFavoriModifPrixActivation(favoris, true);

      setFavoriModifPrix((prev) =>
        prev.map((item: { id: any }) => ({
          ...item,
          actif: item.id === favoris?.id,
        }))
      )
    }

    setOpenFavorisModif(false)
  };

  const applyFilterModifPrix = (favori) => {
    setDateDebut(favori.dateDebut)
    setDateFin(favori.dateFin)
    setTraitee(favori.traitee)
    setSourceSearch(favori.sourcesSearch)
    setSearchPage(favori.searchPage)
    setSortOrder(favori?.tri?.order)
    setSortField(favori?.tri?.key)
    setSelectedLibelles(favori.libellePiece)
    setSelectedEquipes(allowedToManageFavori ? favori.equipe : [] || [])
    setActiveSearch((prev) => !prev)
  }

  const initialFiltersData = () => {
    setDateDebut('')
    setDateFin('')
    setTraitee(traitee)
    setSourceSearch([])
    setSearchPage('')
    setSortOrder('asc')
    setSortField(null)
    setSelectedLibelles([])
    setSelectedEquipes([])
    setActiveSearch((prev) => !prev)
  }

  const handleFavoriModifPrixActivation = (favori, actif) => {
    const toastFavUpdate = toast.loading(`${actif ? 'Activation' : 'Désactivation'} du filtre en cours...`)
    if (!actif) {
      setFilters({
        dateDebut: '',
        dateFin: '',
        traitee: traitee,
        sourcesSearch: [],
        searchPage: '',
        tri: {key: null, order: null},
        libellePiece: [],
        equipe: []
      })
      initialFiltersData()
    } else {
      applyFilterModifPrix(favori?.filterData)
      setFilters(favori?.filterData)
    }

    activateFavoriModifPrix(currentUser?.id, favori?.id, actif).then((res) => {
      setIsFavoriLoaded(true)
      if (res?.status === 200) {
        toast.update(toastFavUpdate, {
          render: `${actif ? 'Activation' : 'Désactivation'} du favori avec succès`,
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })
      } else {
        toast.update(toastFavUpdate, {
          render: `${actif ? 'Activation' : 'Désactivation'} du favori echouée`,
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
        console.error('update failed')
      }
    })
  }

  // Données formatées pour le filtre des équipes
  const getEquipeUtilisateurData = () => {
    getEquipeUtilisateur()
      .then((request) => {
        if (request?.data !== undefined && request?.status === 200) {
          const transformedData = request.data.map((item) => ({
            value: item.id,
            label: item.nom,
          }))
          setEquipes([...transformedData])
        }
      })
      .catch((e) => {
        console.error('erreur: ', e)
      })
  }

  useEffect(function fetchEquipe(){
    const userConnectedEquipes = currentUser?.utilisateurEquipes ?? []
    if (userConnectedEquipes.length) {
      const transformedData = userConnectedEquipes.map((item) => ({
        value: item?.equipe?.id,
        label: item?.equipe?.nom,
      }))
      setEquipes([...transformedData])
    } else {
      getEquipeUtilisateurData()
    }
  }, [])
  const addTeamOnFavori = (values) => {
    setSelectedEquipes(values)
  }

  const handleApply = () => {
    setIsSearch(true)
    setCurrentPage(1)
    setActiveSearch(!activeSearch)

    setFavoriModifPrix((prev) =>
      prev.map((item) => ({
        ...item,
        actif: false,
      }))
    );
  }

  return (
    <>
      {/* begin::Row  */}
      <div className='g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-xxl-12'>
          <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-3 mb-1'>Modification prix</span>
              </h3>
              <div className='d-flex justify-content-center align-items-center gap-3'>
                {shouldDisplayFonctionnalite(currentUser, 'IMPORTER PRIX') && (
                  <div
                    className='card-toolbar'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                    title='Importer'
                  >
                    <button
                      className='btn btn-sm'
                      onClick={() => fileInputRef.current?.click()}
                      style={{backgroundColor: 'antiquewhite'}}
                    >
                      Importer
                    </button>
                    <input
                      type='file'
                      ref={fileInputRef}
                      accept='.csv'
                      style={{display: 'none'}}
                      onChange={handleFileChange}
                    />
                  </div>
                )}
                <div>
                  <button
                    className={`btn btn-sm btn-danger`}
                    onClick={deletePrice}
                    disabled={checkedModifPrice?.length === 0}
                    style={{
                      cursor: checkedModifPrice?.length === 0 ? 'not-allowed' : 'pointer',
                    }}
                  >
                    Supprimer
                  </button>
                </div>
                <div>
                  <button
                    className={`btn btn-sm ${
                      traitee !== 'nonTraitee' ? 'btn-secondary' : 'btn-success'
                    }`}
                    disabled={traitee !== 'nonTraitee'}
                    style={{
                      cursor: traitee !== 'nonTraitee' ? 'not-allowed' : 'pointer',
                    }}
                    onClick={envoiAtemoChange}
                  >
                    {checkedModifPrice?.length && traitee === 'nonTraitee'
                      ? `Envoi Atemo (${checkedModifPrice?.length})`
                      : 'Envoi Atemo'}
                  </button>
                </div>

                {/* début export des données en cours*/}
                <div
                  className='card-toolbar'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title='Exporter'
                >
                  <button className='btn btn-sm btn-light-primary' onClick={() => exportDataCsv()}>
                    Exporter
                  </button>
                </div>
                {/* fin export des données en cours*/}
              </div>
            </div>
            {/* end::Header */}
            {/* debut champs recherche */}
            <form
              className='card-header border-0 py-5 w-100 flex-fill'
              onSubmit={formik.handleSubmit}
            >
              {/*<div className='d-flex col-lg-5'></div>*/}
              {/*<div className='col-lg-12 row align-items-center justify-content-between'>*/}

              {/*  debut recherche statut */}
              <div className='row pt-3 pb-3 col-lg-12 justify-content-end'>
                <div className='d-flex col-lg-12 gap-2 justify-content-end'>
                  {/*<div className='w-bl-statut'>*/}
                  {/*  <button*/}
                  {/*    type='button'*/}
                  {/*    className={`btn-w-statut btn btn-sm ${*/}
                  {/*      traitee === 'tous' ? 'btn-dark' : 'btn-secondary'*/}
                  {/*    } `}*/}
                  {/*    onClick={() => handleStatusChange('tous')}*/}
                  {/*  >*/}
                  {/*    Tous ({totalElement})*/}
                  {/*  </button>*/}
                  {/*</div>*/}
                  <div>
                    <button
                      type='button'
                      className={`btn btn-sm ${
                        traitee === 'nonTraitee' ? 'btn-warning' : 'btn-secondary'
                      } `}
                      onClick={() => handleStatusChange('nonTraitee')}
                    >
                      Non traitées ({totalNonTraitee})
                    </button>
                  </div>
                  <div>
                    <button
                      type='button'
                      className={`btn btn-sm ${
                        traitee === 'prixManuel' ? 'btn-info' : 'btn-secondary'
                      } `}
                      onClick={() => handleStatusChange('prixManuel')}
                    >
                      A tarifier manuellement ({totalPrixManuel})
                    </button>
                  </div>
                  <div>
                    <button
                      type='button'
                      className={`btn btn-sm ${
                        traitee === 'traitee' ? 'btn-success' : 'btn-secondary'
                      } `}
                      onClick={() => handleStatusChange('traitee')}
                    >
                      Traitées ({totalTraitee})
                    </button>
                  </div>
                </div>
              </div>
              {/*  fin recherche statut*/}

              {/* debut recherche champs text*/}

              <div className='row pt-3 pb-3 w-100 mx-0 align-items-start g-3'>
                {traitee === 'traitee' && (
                  <>
                    <div className='col-lg-2 col-md-6'>
                      <DateInput
                        fieldName='dateDebut'
                        inputClassName='form-control'
                        value={dateDebut}
                        setter={setDateDebut}
                        formik={formik}
                        placeholder='Date début'
                        customHeight={true}
                        valueInitialFormat={true}
                      />
                    </div>

                    <div className='col-lg-2 col-md-6'>
                      <DateInput
                        fieldName='dateFin'
                        inputClassName='form-control'
                        value={dateFin}
                        setter={setDateFin}
                        formik={formik}
                        placeholder='Date fin'
                        customHeight={true}
                        valueInitialFormat={true}
                      />
                    </div>
                  </>
                )}

                <div className={`col ${traitee === 'traitee' ? '' : 'col-lg-3'} wi-col`}>
                  <Select
                    styles={customStyles}
                    placeholder='Sources'
                    fieldName='source'
                    className='basic-single'
                    classNamePrefix='select'
                    isClearable={true}
                    isSearchable={true}
                    name='source'
                    onChange={(selectedOptions) => {
                      if (!selectedOptions || selectedOptions.length === 0) {
                        setSourceSearch([])
                      } else {
                        setSourceSearch(selectedOptions.map((option) => option.value))
                      }
                    }}
                    options={sources}
                    isMulti
                    value={sources?.filter((src) => sourcesSearch?.includes(src?.value))}
                  />
                </div>

                <div className={`col ${traitee === 'traitee' ? '' : 'col-lg-4'} wi-col`}>
                  <Select
                    styles={selectLibelleStyle}
                    placeholder='Libellé'
                    fieldName='libelle'
                    className='react-select-styled react-select-solid react-select-lg'
                    classNamePrefix='react-select'
                    options={libelles}
                    isClearable={true}
                    isSearchable={true}
                    name='libelle'
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    blurInputOnSelect={false}
                    filterOption={filterOptions}
                    inputValue={menuInputValue}
                    value={selectedLibelles}
                    onChange={(data) => handleLibelleChange(data)}
                    onInputChange={(text, action) => {
                      if (action.action === 'input-change') {
                        setMenuInputValue(text)
                      } else if (action.action === 'menu-close' || action.action === 'input-blur') {
                        setMenuInputValue('')
                      }
                    }}
                    components={{
                      Option: CustomOption,
                      MultiValue: (props) => {
                        if (props.data.value === 'tous') return null
                        return <components.MultiValue {...props} />
                      },
                    }}
                  />
                </div>

                <div className='col-auto wi-col'>
                  <FavorisModifPrixPopper
                      openFavorisModif={openFavorisModif}
                      setOpenFavorisModif={setOpenFavorisModif}
                      favoriModifLoader={favoriModifLoader}
                      favorisDeleteLoader={favorisDeleteModifLoader}
                      favorisModifPrix={favoriModifPrix}
                      currentUser={currentUser}
                      filters={filters}
                      favoriModifPrix={favoriModifPrix}
                      filterTitle={filterTitle}
                      handleFavorisModifPrixCreation={handleFavorisModifPrixCreation}
                      handleModifPrixFavoriDelete={handleModifPrixFavoriDelete}
                      handleModifPrixFavoriUpdate={handleModifPrixFavoriUpdate}
                      applyFavoris={applyFavoris}
                      favoriUpdateLoader={favoriUpdateLoader}
                      setFilterTitle={setFilterTitle}
                      onEdit={onEdit}
                      setOnEdit={setOnEdit}
                      setShareWithTeam={setShareWithTeam}
                      shareWithTeam={shareWithTeam}
                      equipes={equipes}
                      addTeamOnFavori={addTeamOnFavori}
                      allowedToManageFavori={allowedToManageFavori}
                      setSelectedEquipes={setSelectedEquipes}
                  />
                </div>

                <div className='col wi-col'>
                  <div className='d-flex gap-2 w-100'>
                    <div
                      className='position-relative flex-grow-1'
                      onMouseEnter={() => setDisplayFilter(true)}
                      onMouseLeave={() => setDisplayFilter(false)}
                    >
                      <input
                        type='text'
                        className='form-control h-45px w-100'
                        onChange={(e) => setSearchPage(e.target.value)}
                        name='searchPage'
                        placeholder='Recherche ...'
                      />

                      {displayFilter && <SearchDropDown isPrice={true} />}
                    </div>

                    <button
                      type='button'
                      className={`btn border-0 h-45px flex-shrink-0 ${
                        activeBtn ? 'btn-primary cursor-pointer' : 'btn-light disabled'
                      }`}
                      onClick={handleApply}
                    >
                      <i className='fas fa-search text-secondary fs-1'></i>
                    </button>
                  </div>
                </div>
              </div>

              {/* fin recherche champs text*/}

              {/*</div>*/}
            </form>
            {/* fin champs recherche */}

            {loading ? (
              <LoadingData />
            ) : (
              <>
                {shouldDisplayFonctionnalite(currentUser, 'VOIR MODIF PRIX') && (
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='min-w-50px' style={{paddingLeft: '10px'}}>
                              <input
                                type={'checkbox'}
                                className={'form-check-input'}
                                checked={isAllSelected}
                                onChange={handleSelectAll}
                                disabled={traitee === 'traitee'}
                              />
                            </th>
                            <th className='min-w-150px'>
                              <TableFilter
                                colTitle={'Source'}
                                sortFieldValue='source'
                                setSortField={setSortField}
                                setSortOrder={setSortOrder}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                arrowFilter={true}
                              />
                            </th>
                            <th className='min-w-150px'>
                              <TableFilter
                                colTitle={'Code pièce'}
                                sortFieldValue='codePiece'
                                setSortField={setSortField}
                                setSortOrder={setSortOrder}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                arrowFilter={true}
                              />
                            </th>
                            <th className='min-w-150px'>
                              <TableFilter
                                colTitle={'Ref OE'}
                                sortFieldValue='refConst'
                                setSortField={setSortField}
                                setSortOrder={setSortOrder}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                arrowFilter={true}
                              />
                            </th>
                            <th className='min-w-150px'>
                              <TableFilter
                                colTitle={'Libellé pièce'}
                                sortFieldValue='libPiece'
                                setSortField={setSortField}
                                setSortOrder={setSortOrder}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                arrowFilter={true}
                              />
                            </th>
                            <th className='min-w-150px'>
                              <TableFilter
                                colTitle={'Marque'}
                                sortFieldValue='marque'
                                setSortField={setSortField}
                                setSortOrder={setSortOrder}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                arrowFilter={true}
                              />
                            </th>
                            <th className='min-w-150px'>
                              <TableFilter
                                colTitle={'Modèle'}
                                sortFieldValue='modele'
                                setSortField={setSortField}
                                setSortOrder={setSortOrder}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                arrowFilter={true}
                              />
                            </th>
                            <th className='min-w-150px'>
                              <TableFilter
                                colTitle={'Prix de Vente'}
                                sortFieldValue='prixVente'
                                setSortField={setSortField}
                                setSortOrder={setSortOrder}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                arrowFilter={true}
                              />
                            </th>
                            <th className='min-w-150px'>
                              <TableFilter
                                colTitle={'Nouveau prix'}
                                sortFieldValue='nouveauPrix'
                                setSortField={setSortField}
                                setSortOrder={setSortOrder}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                arrowFilter={true}
                              />
                            </th>
                            <th className='min-w-150px'>
                              <TableFilter
                                colTitle={'Date import'}
                                sortFieldValue='dateImport'
                                setSortField={setSortField}
                                setSortOrder={setSortOrder}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                arrowFilter={true}
                              />
                            </th>
                            <th className='min-w-150px'>
                              {/*<TableFilter*/}
                              {/*  colTitle={'Statut'}*/}
                              {/*  sortFieldValue='statut'*/}
                              {/*  setSortField={setSortField}*/}
                              {/*  setSortOrder={setSortOrder}*/}
                              {/*  sortField={sortField}*/}
                              {/*  sortOrder={sortOrder}*/}
                              {/*  arrowFilter={true}*/}
                              {/*/>*/}
                              <div className='d-flex flex-row justify-content-center align-items-center'>
                                <span>Statut</span>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {dataModifPrix.length ? (
                            dataModifPrix.map((modifPrix) => {
                              return (
                                <tr
                                  onClick={() => showDetail(modifPrix)}
                                  ref={(el) => {
                                    if (modifPrix?.idPieceEntree) {
                                      refPrix.current[modifPrix?.idPieceEntree] = el
                                    }
                                  }}
                                  style={{cursor: 'pointer'}}
                                  key={modifPrix?.idPieceEntree}
                                >
                                  <td>
                                    <input
                                      type={'checkbox'}
                                      className={'form-check-input'}
                                      disabled={traitee === 'traitee'}
                                      onClick={(e) => {
                                        e.stopPropagation()
                                      }}
                                      onChange={(e) =>
                                        addPriceAtemo(e.target.checked, {
                                          id: modifPrix?.id,
                                          prixManuel: modifPrix?.prixManuel,
                                          traitee: modifPrix?.traitee,
                                        })
                                      }
                                      checked={checkedModifPrice
                                        ?.map((item) => item.id)
                                        .includes(modifPrix?.id)}
                                    />
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-center align-items-center fs-6 mb-0'>
                                      {modifPrix?.source ?? modifPrix?.code}
                                    </p>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-center align-items-center fs-6 mb-0'>
                                      {modifPrix?.codePiece && (
                                        <div className='d-flex gap-2'>
                                          {modifPrix?.codePiece}
                                          {checkCopy !== modifPrix?.codePiece ? (
                                            <i
                                              className='ki-duotone ki-copy cursor-pointer fs-2'
                                              onClick={(e) => {
                                                e.stopPropagation()
                                                handleCopie(modifPrix?.codePiece, e)
                                              }}
                                            ></i>
                                          ) : (
                                            <i className='ki-duotone ki-copy-success fs-2'>
                                              <span className='path1'></span>
                                              <span className='path2'></span>
                                            </i>
                                          )}
                                        </div>
                                      )}
                                    </p>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-center align-items-center fs-6 mb-0'>
                                      { modifPrix?.refConst && (
                                      <div className='d-flex gap-2'>
                                        {modifPrix?.refConst}
                                        {checkCopy !== modifPrix?.refConst ? (
                                          <i
                                            className='ki-duotone ki-copy cursor-pointer fs-2'
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              handleCopie(modifPrix?.refConst, e)
                                            }}
                                          ></i>
                                        ) : (
                                          <i className='ki-duotone ki-copy-success fs-2'>
                                            <span className='path1'></span>
                                            <span className='path2'></span>
                                          </i>
                                        )}
                                      </div>
                                      )}
                                    </p>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-left align-items-left fs-6 mb-0'>
                                      {modifPrix?.nomPiece}
                                    </p>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-left align-items-left fs-6 mb-0'>
                                      {modifPrix?.marque}
                                    </p>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-left align-items-left fs-6 mb-0'>
                                      {modifPrix?.modele}
                                    </p>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-center align-items-center fs-6 mb-0'>
                                      {modifPrix?.prixVente}
                                    </p>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-center align-items-center fs-6 mb-0'>
                                      {modifPrix?.nouveauPrix}
                                    </p>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-center align-items-center fs-6 mb-0'>
                                      {modifPrix?.dateImport &&
                                        moment(modifPrix?.dateImport).format('DD/MM/YYYY HH:mm')}
                                    </p>
                                  </td>
                                  <td>
                                    <p className='text-dark fw-bold text-hover-primary d-flex justify-content-center align-items-center fs-6 mb-0'>
                                      {handleStatut(modifPrix?.traitee, modifPrix?.prixManuel)}
                                    </p>
                                  </td>
                                </tr>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={12} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      locationState={0}
                    />
                    {/* end::pagination*/}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
        <DetailsModal
          data={0}
          dataPrix={dataModal}
          dataModifPrix={dataModifPrix}
          currentIndexPrix={currentIndex}
          showNextModal={showNextModal}
          setDataModifPrix={setDataModifPrix}
          isNothingToNext={isNothingToNext}
          setTotalPrixManuel={setTotalPrixManuel}
          totalPrixManuel={totalPrixManuel}
          totalNontraitee={totalNonTraitee}
          setTotalNontraitee={setTotalNonTraitee}
          onDeleteData={onDeleteData}
        />
      </div>
      {/* end::Row  */}
    </>
  )
}

export {ModifPrixListPage}
